import React, { memo, forwardRef } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ComoButton } from "../Common/ComoButton";

interface ActionButtonsProps {
  isSubmitting: boolean;
  isValid: boolean;
  action: "create" | "edit";
  onSubmit: () => void;
  onCancel: () => void;
}

const ActionButtons = memo(
  forwardRef<HTMLDivElement, ActionButtonsProps>(
    ({ isSubmitting, isValid, action, onSubmit, onCancel }, ref) => {
      const { t } = useTranslation("createQuestionList");

      return (
        <Box
          ref={ref}
          sx={{ display: "flex", justifyContent: "center", gap: 3, pt: 4 }}
        >
          <ComoButton onClick={onSubmit}>
            {isSubmitting ? (
              <CircularProgress size={24} color="inherit" />
            ) : action === "edit" ? (
              t("createQuestionList.updateQuestionList")
            ) : (
              t("createQuestionList.createQuestionList")
            )}
          </ComoButton>

          <ComoButton secondary onClick={onCancel}>
            {t("createQuestionList.cancelButton")}
          </ComoButton>
        </Box>
      );
    },
  ),
);

ActionButtons.displayName = "ActionButtons";

export default ActionButtons;
